module.exports = __webpack_public_path__ + "2ff9f44b5c0aa608534ff5a7ebe76626.jpg";